export default __webpack_public_path__ + "static/media/video.87c3a087.mp4";